<template>
  <div>
    医院名称：
    <br />
    <el-input v-model="hospitalName" placeholder="请输入医院名称" clearable maxlength="10" minlength="1"></el-input>
    <br />
    <br />
    用户账号：
    <br />
    <el-input v-model="creatorId" placeholder="请输入创建者账号" clearable maxlength="11" minlength="11"></el-input>
    <br />
    <br />
    <el-button type="primary" @click="createHospital">创建医院</el-button>
  </div>
</template>

<script>
import axios from "axios";
import Global from "../Global";

export default {
  name: "CreateHospital",
  data() {
    return {
      hospitalName: '',
      creatorId: ''
    }
  },
  methods: {
    createHospital() {
      let hospitalName = this.hospitalName
      let creatorId = this.creatorId
      this.axios({
        method: 'POST',
        url: Global.yunyingUrl + '/service-hospital/hospital/addFusuHospital',
        data: {
          'hospitalName': hospitalName,
          'creatorId': creatorId
        }
      }).then(resp => {
        let data = resp.data
        if (data.code === 1000) {
          this.$message.success('创建医院成功')
        } else {
          this.$message.error(data.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/hospital_manage/CreateHospital.vue